import { useCallback, useEffect, useState } from 'react';

export type UploadDataView = 'list' | 'grid';

export const defaultDataView: UploadDataView = 'list';
export const DATA_VIEW_KEY = 'uploads-data-view';

const isUploadDataView = (str: any): str is UploadDataView => str === 'list' || str === 'grid';

export const useDataView = () => {
  const [dataView, setDataView] = useState<UploadDataView>(defaultDataView);

  const updateDataView = useCallback(
    (next: UploadDataView) => {
      storeDataView(next);
      setDataView(next);
    },
    [setDataView],
  );

  useEffect(() => {
    setDataView(getStoredDataView() || defaultDataView);
  }, []);

  return { dataView, setDataView: updateDataView };
};

export const getStoredDataView = (): UploadDataView | null => {
  const dataView = localStorage.getItem(DATA_VIEW_KEY);
  return isUploadDataView(dataView) ? dataView : null;
};
export const storeDataView = (dataView: UploadDataView) =>
  localStorage.setItem(DATA_VIEW_KEY, dataView);
